import request from '@/utils/request'


// 查询机构课程列表
export function listCourse(query) {
  return request({
    url: '/course/course/list',
    method: 'get',
    params: query
  })
}

// 查询机构课程分页
export function pageCourse(query) {
  return request({
    url: '/course/course/page',
    method: 'get',
    params: query
  })
}

// 查询机构课程详细
export function getCourse(data) {
  return request({
    url: '/course/course/detail',
    method: 'get',
    params: data
  })
}

// 新增机构课程
export function addCourse(data) {
  return request({
    url: '/course/course/add',
    method: 'post',
    data: data
  })
}

// 修改机构课程
export function updateCourse(data) {
  return request({
    url: '/course/course/edit',
    method: 'post',
    data: data
  })
}

// 删除机构课程
export function delCourse(data) {
  return request({
    url: '/course/course/delete',
    method: 'post',
    data: data
  })
}
